import { ErrorHandler, Inject, Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';

import { AirportService } from '../../airport/airport.service';
import { Business } from '../../business/models/business.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';


@Injectable()
export class BusinessResolver implements Resolve<Business> {
  constructor(
    @Inject(DOCUMENT) private document: any,
    private _router: Router,
    private _airportService: AirportService,
    private _errorHandler: ErrorHandler,
    private _toggleService: EditToggleService
  ) { }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Business> {
    try {
      const id = route.paramMap.get('id');
      const business = await this._airportService.getBusiness(id);
      this._toggleService.setState(false);
      if (business) {
        return business;
      }
      this._router.navigate(['/404']);
      return null;
    } catch (e) {
      this._errorHandler.handleError(e);
      this._router.navigate(['/500']);
    }
  }
}
